import { render, staticRenderFns } from "./RecordingConsentSettings.vue?vue&type=template&id=d251b470"
import script from "./RecordingConsentSettings.vue?vue&type=script&lang=js"
export * from "./RecordingConsentSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports